export const validaAnvisa = (codigo: string) => {
    return codigo.length === 13;
}